import React, { Component } from 'react';
import { connect } from 'react-redux';
import PermissaoUsuario from '../../auth/permissao';
import ButtonTooltip from '../../common/form/buttonTooltip';
import OrdemServicoRelatorioExcelModal from './ordemServicoRelatorioExcelModal';
import {
  PERIODOS_RELATORIO,
  agruparPor,
  filtrarOrdensRelatorio,
  osSlaVencida,
  osEstaAberta,
  resumoPorCruzamento,
  resumoPorEquipe,
} from './ordemServicoRelatorioUtils';

const STATUS_LABELS = {
  ABERTA: 'Aberta',
  AGUARDANDO_MATERIAL: 'Aguard. material',
  EM_ATENDIMENTO: 'Em atendimento',
  AGUARDANDO_VALIDACAO: 'Aguard. validação',
  FINALIZADA: 'Finalizada',
  CANCELADA: 'Cancelada',
};

const STATUS_CORES = {
  ABERTA: '#3c8dbc',
  AGUARDANDO_MATERIAL: '#f39c12',
  EM_ATENDIMENTO: '#8e44ad',
  AGUARDANDO_VALIDACAO: '#16a085',
  FINALIZADA: '#27ae60',
  CANCELADA: '#94a3b8',
};

function KpiCard({ label, valor, cor, icone }) {
  return (
    <div className="os-relatorio-kpi-card">
      <div className="os-relatorio-kpi-icon" style={{ color: cor }}>
        <i className={`fa fa-${icone}`} />
      </div>
      <div className="os-relatorio-kpi-body">
        <span className="os-relatorio-kpi-label">{label}</span>
        <strong className="os-relatorio-kpi-valor" style={{ color: cor }}>
          {valor}
        </strong>
      </div>
    </div>
  );
}

function TabelaAgrupamento({ titulo, dados, corMap, labelMap }) {
  const entradas = Object.entries(dados).sort((a, b) => b[1] - a[1]);
  if (entradas.length === 0) return null;

  const total = entradas.reduce((sum, [, qtd]) => sum + qtd, 0);

  return (
    <div className="os-relatorio-tabela-card">
      <div className="os-relatorio-tabela-card-header">
        <h5>{titulo}</h5>
        <span>{total} registro(s)</span>
      </div>
      <div className="os-relatorio-tabela-wrap">
        <table className="os-relatorio-tabela">
          <thead>
            <tr>
              <th>Descrição</th>
              <th>Qtd.</th>
              <th>%</th>
            </tr>
          </thead>
          <tbody>
            {entradas.map(([nome, qtd]) => {
              const pct = total > 0 ? Math.round((qtd / total) * 100) : 0;
              const cor = corMap && corMap[nome];
              const label = labelMap && labelMap[nome] ? labelMap[nome] : nome;

              return (
                <tr key={nome}>
                  <td>
                    <span className="os-relatorio-tabela-label">
                      {cor ? <span className="os-relatorio-tabela-dot" style={{ background: cor }} /> : null}
                      {label}
                    </span>
                  </td>
                  <td className="os-relatorio-tabela-qtd">{qtd}</td>
                  <td className="os-relatorio-tabela-pct">
                    <span className="os-relatorio-tabela-bar-wrap">
                      <span className="os-relatorio-tabela-bar" style={{ width: `${pct}%`, background: cor || '#3c8dbc' }} />
                    </span>
                    {pct}%
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function TabelaResumoDetalhado({ titulo, linhas, colunaNome, nomeCampo }) {
  if (!linhas.length) return null;

  return (
    <div className="os-relatorio-tabela-card os-relatorio-tabela-card--detalhado">
      <div className="os-relatorio-tabela-card-header">
        <h5>{titulo}</h5>
        <span>{linhas.length} registro(s)</span>
      </div>
      <div className="os-relatorio-tabela-wrap">
        <table className="os-relatorio-tabela os-relatorio-tabela--detalhado">
          <thead>
            <tr>
              <th>{colunaNome}</th>
              <th>Total</th>
              <th>Abertas</th>
              <th>Finalizadas</th>
              <th>SLA vencido</th>
            </tr>
          </thead>
          <tbody>
            {linhas.map(linha => (
              <tr key={linha[nomeCampo]}>
                <td>{linha[nomeCampo]}</td>
                <td className="os-relatorio-tabela-qtd">{linha.total}</td>
                <td>{linha.abertas}</td>
                <td>{linha.finalizadas}</td>
                <td className={linha.slaVencido > 0 ? 'os-relatorio-tabela-sla-vencido' : ''}>{linha.slaVencido}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

class OrdemServicoRelatorio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showRelatorioModal: false,
      periodo: '90',
      equipeId: '',
    };
  }

  render() {
    const { periodo, equipeId } = this.state;
    const opcoes = this.props.opcoes || {};
    const equipes = opcoes.equipes || [];
    const ordens = filtrarOrdensRelatorio(this.props.list || [], { periodo, equipeId });
    const abertas = ordens.filter(osEstaAberta);
    const vencidas = ordens.filter(osSlaVencida);

    const porStatus = agruparPor(ordens, 'status');
    const porEquipe = agruparPor(ordens, 'equipe_nome');
    const porTipo = agruparPor(ordens, 'tipo');
    const resumoEquipes = resumoPorEquipe(ordens);
    const resumoCruzamentos = resumoPorCruzamento(ordens);

    const periodoLabel = (PERIODOS_RELATORIO.find(p => p.value === periodo) || {}).label || '';
    const equipeLabel = equipeId
      ? (equipes.find(e => String(e.id) === String(equipeId)) || {}).nome || equipeId
      : 'Todas';

    return (
      <div className="simple-cad-form-premium os-relatorio-premium" style={{ marginTop: 20 }}>
        <div className="simple-cad-premium-container">
          <div className="simple-cad-premium-card">
            <div className="simple-cad-premium-header simple-cad-premium-header--actions">
              <div>
                <h4>
                  <i className="fa fa-chart-bar" /> Resumo Operacional
                </h4>
                <p>
                  Visão por equipe e cruzamento — período: {periodoLabel}
                  {equipeId ? ` · equipe: ${equipeLabel}` : ''}.
                </p>
              </div>
              <div className="os-relatorio-toolbar">
                <div className="os-relatorio-toolbar-field">
                  <label htmlFor="os-relatorio-periodo">Período</label>
                  <select
                    id="os-relatorio-periodo"
                    className="form-control"
                    value={periodo}
                    onChange={e => this.setState({ periodo: e.target.value })}
                  >
                    {PERIODOS_RELATORIO.map(p => (
                      <option key={p.value} value={p.value}>
                        {p.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="os-relatorio-toolbar-field">
                  <label htmlFor="os-relatorio-equipe">Equipe</label>
                  <select
                    id="os-relatorio-equipe"
                    className="form-control"
                    value={equipeId}
                    onChange={e => this.setState({ equipeId: e.target.value })}
                  >
                    <option value="">Todas</option>
                    {equipes.map(e => (
                      <option key={e.id} value={e.id}>
                        {e.nome}
                      </option>
                    ))}
                  </select>
                </div>
                <PermissaoUsuario tela="CadOrdemServico" campo="relatorio" condicao={true}>
                  <ButtonTooltip
                    type="button"
                    className="default premium-header-report-btn"
                    icon="print"
                    label=""
                    data-title="Exportar relatório"
                    onClick={() => this.setState({ showRelatorioModal: true })}
                  />
                </PermissaoUsuario>
              </div>
            </div>
            <div className="simple-cad-premium-body">
              <div className="os-relatorio-kpi-grid">
                <KpiCard label="Total de OS" valor={ordens.length} cor="#2d3748" icone="clipboard-list" />
                <KpiCard label="Em aberto" valor={abertas.length} cor="#3c8dbc" icone="clock" />
                <KpiCard
                  label="SLA vencido"
                  valor={vencidas.length}
                  cor={vencidas.length > 0 ? '#e74c3c' : '#27ae60'}
                  icone="exclamation-triangle"
                />
                <KpiCard label="Finalizadas" valor={porStatus.FINALIZADA || 0} cor="#27ae60" icone="check-circle" />
              </div>

              <div className="os-relatorio-tabelas-grid os-relatorio-tabelas-grid--detalhado">
                <TabelaResumoDetalhado
                  titulo="Desempenho por equipe"
                  linhas={resumoEquipes}
                  colunaNome="Equipe"
                  nomeCampo="equipe"
                />
                <TabelaResumoDetalhado
                  titulo="Desempenho por cruzamento"
                  linhas={resumoCruzamentos}
                  colunaNome="Cruzamento"
                  nomeCampo="cruzamento"
                />
              </div>

              <div className="os-relatorio-tabelas-grid">
                <TabelaAgrupamento
                  titulo="Por status"
                  dados={porStatus}
                  corMap={STATUS_CORES}
                  labelMap={STATUS_LABELS}
                />
                <TabelaAgrupamento titulo="Por equipe" dados={porEquipe} />
                <TabelaAgrupamento titulo="Por tipo" dados={porTipo} />
              </div>

              {vencidas.length > 0 && (
                <div className="os-relatorio-vencidas-panel">
                  <div className="os-relatorio-vencidas-header">
                    <h5>
                      <i className="fa fa-exclamation-triangle" /> OS com prazo vencido
                    </h5>
                    <span>{vencidas.length} ordem(ns)</span>
                  </div>
                  <div className="os-relatorio-tabela-wrap">
                    <table className="os-relatorio-tabela os-relatorio-tabela--vencidas">
                      <thead>
                        <tr>
                          <th>Número</th>
                          <th>Título</th>
                          <th>Cruzamento</th>
                          <th>Equipe</th>
                          <th>Prazo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {vencidas.map(o => (
                          <tr key={o.id}>
                            <td className="os-relatorio-tabela-numero">{o.numero}</td>
                            <td>{o.titulo}</td>
                            <td>{o.cruzamento || (o.controlador_numero ? `Ctrl ${o.controlador_numero}` : '—')}</td>
                            <td>{o.equipe_nome || '—'}</td>
                            <td className="os-relatorio-tabela-prazo">
                              {o.data_prazo ? new Date(o.data_prazo).toLocaleString('pt-BR') : '—'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {this.state.showRelatorioModal && (
          <OrdemServicoRelatorioExcelModal
            show={this.state.showRelatorioModal}
            onClose={() => this.setState({ showRelatorioModal: false })}
            opcoes={this.props.opcoes}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.manutencaoOS.list,
  opcoes: state.manutencaoOS.opcoes,
});

export default connect(mapStateToProps)(OrdemServicoRelatorio);
